<template>
	<div>
		<Sidebar />
	</div>
</template>

<script>
import Sidebar from '@/components/layout/vo/Sidebar';

export default {
	components: {
		Sidebar
	},
	created() {
	}

};

</script>